module.exports = __webpack_public_path__ + "media/images/payment/visa-e70ae2038cbb25164963118a2be4a835.png";